/**
 * Secondary line label for `account.checks` (checkbook request) rows in transaction lists.
 *
 * Draft payloads or incomplete refreshes after navigation may omit `checksTypes`; in that case the activity title from
 * i18n is shown instead.
 *
 * @param {object} [transactionData] Transaction `data` object from list/card payloads.
 * @returns {string} Resolved display label for the additional-info column.
 */
function getAccountChecksTransactionAdditionalLabel(transactionData) {
    const label = transactionData?.checksTypes?.label;
    if (typeof label === "string" && label.trim() !== "") {
        return label;
    }
    return "-";
}

export default getAccountChecksTransactionAdditionalLabel;
